const imgTeamGraphic1Main = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingGra11 = "./assets/figma/ce138cea-56d6-46df-8d97-60651a7cab75.png";
const imgEllipse37 = "./assets/figma/913dc448-4698-43da-9d8b-57b058da291a.svg";
const img1 = "./assets/figma/1bfb9ab2-d305-4ac6-8026-6b7b0115e017.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine21 = "./assets/figma/855ab069-959b-4910-953b-d071eec60edc.svg";
const imgEllipse30 = "./assets/figma/1ae59d87-204d-4d97-9d60-7e3ec572078b.svg";
const imgEllipse31 = "./assets/figma/3d0347f5-34a4-40ac-a394-a629b71a4725.svg";
const imgEllipse32 = "./assets/figma/99e3dab6-5896-4f0a-beb4-2915fc9c0abd.svg";
const imgArrow5 = "./assets/figma/86fee700-6c89-4ef3-a41a-21b7518ecb91.svg";

export default function TeamGraphic1Main() {
  return (
    <div className="s0 s1" data-node-id="856:2547" data-name="TEAM_GRAPHIC_1_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s258 s1" src={imgTeamGraphic1Main} />
      </div>
      <div className="s106 s259 s2 s126 s260 s261" data-node-id="1013:8" data-name="DING_GRA1 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingGra11} />
      </div>
      <div className="s2 s267 s268 s269 s270" data-node-id="856:2554" data-name="image 14" />
      <div className="s259 s2 s16 s17 s24 s230 s26 s303 s277 s304" data-node-id="856:2555" data-name="TAB_TEAM">
        <div className="s16 s81 s17 s305 s18 s306 s307 s464 s309 s0 s145 s28 s34" data-node-id="856:2556" data-name="TAB_TEAM_GRAPHIC1">
          <div aria-hidden className="s2 s152 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="856:2557">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s319" data-node-id="856:2558">
              GRAPHIC 1
            </p>
            <div className="s0 s28 s320" data-node-id="856:2559">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgEllipse37} />
            </div>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </div>
        <a className="s16 s141 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s34" data-node-id="856:2560" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="856:2561">
            GRAPHIC 2
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s24 s305 s26 s42 s311 s307 s312 s309 s0 s145 s146 s28 s34" data-node-id="856:2562" data-name="TAB_TEAM_UI/UX">
          <div aria-hidden className="s2 s313 s3 s4 s145" />
          <div className="s16 s17 s314 s18 s19 s0 s28 s315" data-node-id="856:2563">
            <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="856:2564">
              UI/UX
            </p>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s311 s307 s316 s309 s0 s145 s146 s28 s34" data-node-id="856:2565" data-name="TAB_TEAM_PACKAGE">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="856:2566">
            PACKAGE
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s306 s307 s317 s309 s0 s145 s146 s28 s34" data-node-id="856:2567" data-name="TAB_TEAM_MOTION">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="856:2568">
            MOTION
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="857:4628" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="857:4629">
          <div className="s111 s0 s28 s112" data-node-id="857:4630" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="857:4635">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="857:4636">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="857:4637">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="857:4638">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="857:4639">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="857:4640">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="857:4641">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="857:4642">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="857:4643">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="857:4644">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="857:4645">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s259 s2 s16 s17 s24 s271 s18 s19 s466 s273 s274 s275 s276 s145 s146 s277 s278" data-node-id="856:2569">
        <div aria-hidden className="s2 s147 s3 s4 s145" />
        <div className="s16 s17 s24 s279 s26 s0 s28 s280" data-node-id="856:2570">
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s34" data-node-id="856:2571">
            graphic 1 AI RECIPE
          </p>
          <div className="s46 s0 s28 s34" data-node-id="856:2572">
            <div className="s2 s48">
              <img alt="" className="s49 s9 s1" src={imgLine21} />
            </div>
          </div>
        </div>
        <div className="s16 s17 s24 s293 s1067 s26 s0 s28 s297" data-node-id="856:2577">
          <div className="s16 s17 s298 s18 s0 s28 s34" data-node-id="856:2578">
            <div className="s0 s28 s299" data-node-id="856:2579">
              <div className="s2 s300">
                <img alt="" className="s49 s9 s1" src={imgEllipse30} />
              </div>
            </div>
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="856:2580">
              CHATGPT
            </p>
          </div>
          <div className="s16 s17 s298 s18 s0 s28" data-node-id="856:2581">
            <div className="s0 s28 s299" data-node-id="856:2582">
              <div className="s2 s300">
                <img alt="" className="s49 s9 s1" src={imgEllipse31} />
              </div>
            </div>
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="856:2583">
              JEMINI
            </p>
          </div>
          <div className="s16 s17 s298 s18 s0 s28" data-node-id="856:2584">
            <div className="s0 s28 s299" data-node-id="856:2585">
              <div className="s2 s300">
                <img alt="" className="s49 s9 s1" src={imgEllipse32} />
              </div>
            </div>
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="856:2586">
              FIREFLY
            </p>
          </div>
        </div>
        <a className="s282 s16 s141 s17 s24 s283 s284 s18 s42 s285 s286 s287 s0 s145 s146 s28 s288 s289 s290" data-node-id="856:2573" data-name="ARCHIVE1">
          <div className="s16 s17 s18 s19 s0 s28 s34" data-node-id="856:2574">
            <p className="s23 s31 s32 s27 s0 s28 s29 s37 s149 s54" data-node-id="856:2575">
              ARCHIVE
            </p>
            <div className="s46 s0 s28 s291" data-node-id="856:2576">
              <div className="s2 s292">
                <img alt="" className="s49 s9 s1" src={imgArrow5} />
              </div>
            </div>
          </div>
        </a>
        <div className="s2 s3 s4 s150 s151" />
      </div>
    </div>
  );
}